import * as RadixTooltip from '@radix-ui/react-tooltip';


type TooltipProps = {
  children: React.ReactNode
  content: string
  className?: string
  side?: 'top' | 'right' | 'bottom' | 'left'
}

export const Tooltip = (props: TooltipProps) => {
  const { children, content, side = 'right' } = props
  return (
    <RadixTooltip.Provider>
    <RadixTooltip.Root>
      <RadixTooltip.Trigger asChild>
        {children}
      </RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content sideOffset={5} side={side}>
          {/* TODO - not sure why not accepting tailwind classes */}
          <div style={{ backgroundColor: 'rgba(0, 0, 0, 0.8)', color: 'white', padding: '8px 14px', borderRadius: '5px', fontFamily: 'Inter, sans-serif', fontSize: '14px', fontWeight: '400', lineHeight: '1', textAlign: 'center' }}>
            {content}
          </div>
          <RadixTooltip.Arrow className="RadixTooltipArrow" style={{ fill: 'rgba(0, 0, 0, 0.8)' }} />
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  </RadixTooltip.Provider>
  )
}